module.exports = __webpack_public_path__ + "back-arrow.png?60643ff33fb756dd1a2cb99a7bd72d20";